import { utils, writeFile } from "xlsx";

interface AttendanceRecord {
  attendence: boolean;
  batchCode: string;
  createdAt: string;
  date: string;
  month: number;
  student: string;
  studentName: string;
  updatedAt: string;
  year: number;
  __v: number;
  _id: string;
}

const handleExport = (
  filteredData,
  totalDays,
  presentDays,
  absentDays,
  attendancePercentage,
  selectedMonth,
  selectedYear
) => {
  if (!filteredData) return;

  // Create summary data
  const summaryData = [
    ["Attendance Summary"],
    ["Metric", "Value"],
    ["Total Classes", totalDays],
    ["Present Days", presentDays],
    ["Absent Days", absentDays],
    ["Attendance Percentage", `${attendancePercentage.toFixed(2)}%`],
    [], // Empty row for spacing
  ];

  // Create headers for attendance data
  const headers = ["Student Name", "Batch Code", "Date", "Status"];

  // Transform attendance data
  const attendanceData = filteredData.map((record: AttendanceRecord) => [
    record.studentName,
    record.batchCode,
    new Date(record.date).toLocaleDateString(),
    record.attendence ? "Present" : "Absent",
  ]);

  // Combine all data
  const exportData = [headers, ...attendanceData, [], ...summaryData];

  // Create workbook and worksheet
  const wb = utils.book_new();
  const ws = utils.aoa_to_sheet(exportData);

  // Set column widths
  const colWidths = [
    { wch: 20 }, // Student Name
    { wch: 15 }, // Batch Code
    { wch: 15 }, // Date
    { wch: 10 }, // Status
  ];
  ws["!cols"] = colWidths;

  // Add worksheet to workbook
  utils.book_append_sheet(wb, ws, "Attendance Report");

  // Generate filename based on selected filters
  const monthStr = selectedMonth || "All-Months";
  const filename = `Attendance_Report_${monthStr}.xlsx`;

  // Export file
  writeFile(wb, filename);
};

export default handleExport;
